const loadingAnimation = {
  v: '4.6.3',
  fr: 29.9700012207031,
  ip: 0,
  op: 35.0000014255792,
  w: 400,
  h: 400,
  nm: 'Comp 1',
  ddd: 0,
  assets: [],
  layers: [
    {
      ddd: 0,
      ind: 1,
      ty: 4,
      nm: 'Shape Layer 1',
      ks: {
        o: { a: 0, k: 100 },
        r: { a: 0, k: 0 },
        p: { a: 0, k: [200, 205, 0] },
        a: { a: 0, k: [0, 0, 0] },
        s: { a: 0, k: [77.411, 77.411, 100] }
      },
      ao: 0,
      shapes: [
        {
          ty: 'gr',
          it: [
            {
              d: 1,
              ty: 'el',
              s: { a: 0, k: [288.949, 288.949] },
              p: { a: 0, k: [0, 0] },
              nm: 'Ellipse Path 1',
              mn: 'ADBE Vector Shape - Ellipse'
            },
            {
              ty: 'tm',
              s: {
                a: 1,
                k: [
                  {
                    i: { x: [0.667], y: [-2.959] },
                    o: { x: [0.333], y: [0] },
                    n: ['0p667_-2p959_0p333_0'],
                    t: 0,
                    s: [6],
                    e: [7.98]
                  },
                  {
                    i: { x: [0.667], y: [1] },
                    o: { x: [0.333], y: [0.226] },
                    n: ['0p667_1_0p333_0p226'],
                    t: 4,
                    s: [7.98],
                    e: [34]
                  },
                  {
                    i: { x: [0.667], y: [1] },
                    o: { x: [0.333], y: [0] },
                    n: ['0p667_1_0p333_0'],
                    t: 7,
                    s: [34],
                    e: [54]
                  },
                  {
                    i: { x: [0.667], y: [1] },
                    o: { x: [0.333], y: [0] },
                    n: ['0p667_1_0p333_0'],
                    t: 12,
                    s: [54],
                    e: [100]
                  },
                  {
                    i: { x: [0.667], y: [0.667] },
                    o: { x: [0.333], y: [0.333] },
                    n: ['0p667_0p667_0p333_0p333'],
                    t: 19,
                    s: [100],
                    e: [100]
                  },
                  { t: 35.0000014255792 }
                ],
                ix: 1
              },
              e: {
                a: 1,
                k: [
                  {
                    i: { x: [0.667], y: [1] },
                    o: { x: [0.333], y: [0] },
                    n: ['0p667_1_0p333_0'],
                    t: 0,
                    s: [0],
                    e: [47]
                  },
                  {
                    i: { x: [0.667], y: [1] },
                    o: { x: [0.333], y: [0] },
                    n: ['0p667_1_0p333_0'],
                    t: 24,
                    s: [47],
                    e: [92]
                  },
                  { t: 35.0000014255792 }
                ],
                ix: 2
              },
              o: {
                a: 1,
                k: [
                  {
                    i: { x: [0.667], y: [1] },
                    o: { x: [0.333], y: [0] },
                    n: ['0p667_1_0p333_0'],
                    t: 0,
                    s: [-70],
                    e: [46]
                  },
                  {
                    i: { x: [0.667], y: [1] },
                    o: { x: [0.333], y: [0] },
                    n: ['0p667_1_0p333_0'],
                    t: 7,
                    s: [46],
                    e: [115]
                  },
                  {
                    i: { x: [0.667], y: [1] },
                    o: { x: [0.333], y: [0] },
                    n: ['0p667_1_0p333_0'],
                    t: 12,
                    s: [115],
                    e: [144]
                  },
                  {
                    i: { x: [0.667], y: [1] },
                    o: { x: [0.333], y: [0] },
                    n: ['0p667_1_0p333_0'],
                    t: 19,
                    s: [144],
                    e: [173]
                  },
                  {
                    i: { x: [0.667], y: [1] },
                    o: { x: [0.333], y: [0] },
                    n: ['0p667_1_0p333_0'],
                    t: 24,
                    s: [173],
                    e: [309]
                  },
                  { t: 35.0000014255792 }
                ],
                ix: 3
              },
              m: 1,
              ix: 2,
              nm: 'Trim Paths 1',
              mn: 'ADBE Vector Filter - Trim'
            },
            {
              ty: 'st',
              c: {
                a: 0,
                k: [0, 0.8352941176470589, 0.592156862745098, 1]
              },
              o: { a: 0, k: 100 },
              w: { a: 0, k: 14 },
              lc: 2,
              lj: 1,
              ml: 4,
              nm: 'Stroke 1',
              mn: 'ADBE Vector Graphic - Stroke'
            },
            {
              ty: 'tr',
              p: { a: 0, k: [2.549, -5.717], ix: 2 },
              a: { a: 0, k: [0, 0], ix: 1 },
              s: { a: 0, k: [108.139, 108.139], ix: 3 },
              r: { a: 0, k: 0, ix: 6 },
              o: { a: 0, k: 100, ix: 7 },
              sk: { a: 0, k: 0, ix: 4 },
              sa: { a: 0, k: 0, ix: 5 },
              nm: 'Transform'
            }
          ],
          nm: 'big_circle',
          np: 4,
          cix: 2,
          ix: 1,
          mn: 'ADBE Vector Group'
        },
        {
          ty: 'gr',
          it: [
            {
              d: 1,
              ty: 'el',
              s: { a: 0, k: [288.949, 288.949] },
              p: { a: 0, k: [0, 0] },
              nm: 'Ellipse Path 1',
              mn: 'ADBE Vector Shape - Ellipse'
            },
            {
              ty: 'tm',
              s: {
                a: 1,
                k: [
                  {
                    i: { x: [0.667], y: [1] },
                    o: { x: [0.333], y: [0] },
                    n: ['0p667_1_0p333_0'],
                    t: 1,
                    s: [0],
                    e: [22.284]
                  },
                  {
                    i: { x: [0.667], y: [1] },
                    o: { x: [0.333], y: [0] },
                    n: ['0p667_1_0p333_0'],
                    t: 15,
                    s: [22.284],
                    e: [84]
                  },
                  { t: 35.0000014255792 }
                ],
                ix: 1
              },
              e: {
                a: 1,
                k: [
                  {
                    i: { x: [0.667], y: [1] },
                    o: { x: [0.333], y: [0] },
                    n: ['0p667_1_0p333_0'],
                    t: 0,
                    s: [13],
                    e: [100]
                  },
                  {
                    i: { x: [0.667], y: [0.667] },
                    o: { x: [0.333], y: [0.333] },
                    n: ['0p667_0p667_0p333_0p333'],
                    t: 15,
                    s: [100],
                    e: [100]
                  },
                  {
                    i: { x: [0.667], y: [0.667] },
                    o: { x: [0.333], y: [0.333] },
                    n: ['0p667_0p667_0p333_0p333'],
                    t: 29,
                    s: [100],
                    e: [100]
                  },
                  { t: 35.0000014255792 }
                ],
                ix: 2
              },
              o: {
                a: 1,
                k: [
                  {
                    i: { x: [0.833], y: [0.833] },
                    o: { x: [0.333], y: [0] },
                    n: ['0p833_0p833_0p333_0'],
                    t: 1,
                    s: [-22],
                    e: [11]
                  },
                  {
                    i: { x: [0.833], y: [0.833] },
                    o: { x: [0.167], y: [0.167] },
                    n: ['0p833_0p833_0p167_0p167'],
                    t: 33,
                    s: [11],
                    e: [22]
                  },
                  { t: 35.0000014255792 }
                ],
                ix: 3
              },
              m: 1,
              ix: 2,
              nm: 'Trim Paths 1',
              mn: 'ADBE Vector Filter - Trim'
            },
            {
              ty: 'st',
              c: {
                a: 0,
                k: [0, 0.8352941176470589, 0.592156862745098, 1]
              },
              o: { a: 0, k: 100 },
              w: { a: 0, k: 19 },
              lc: 2,
              lj: 1,
              ml: 4,
              nm: 'Stroke 1',
              mn: 'ADBE Vector Graphic - Stroke'
            },
            {
              ty: 'tr',
              p: { a: 0, k: [2.549, -5.717], ix: 2 },
              a: { a: 0, k: [0, 0], ix: 1 },
              s: { a: 0, k: [72.226, 72.226], ix: 3 },
              r: { a: 0, k: 0, ix: 6 },
              o: { a: 0, k: 100, ix: 7 },
              sk: { a: 0, k: 0, ix: 4 },
              sa: { a: 0, k: 0, ix: 5 },
              nm: 'Transform'
            }
          ],
          nm: 'small_circle',
          np: 4,
          cix: 2,
          ix: 2,
          mn: 'ADBE Vector Group'
        }
      ],
      ip: 0,
      op: 900.000036657751,
      st: 0,
      bm: 0,
      sr: 1
    }
  ]
}

export default loadingAnimation
